import { ref, computed } from 'vue'
import { translations, locales } from './translations'

const currentLocale = ref('en-US')

const monthKeys = [
  'january', 'february', 'march', 'april', 'may', 'june',
  'july', 'august', 'september', 'october', 'november', 'december'
]

export function useI18n() {
  const t = (key, params = {}) => {
    const localeTranslations = translations[currentLocale.value] || translations['en-US']
    
    // Support nested keys like "months.march"
    const text = key.split('.').reduce((obj, k) => obj?.[k], localeTranslations) || key
    return text.replace?.(/\{(\w+)\}/g, (_, k) => params[k] || `{${k}}`) || text
  }

  const formatMonth = (monthKey) => {
    // monthKey format: "2024-03" or "March 2024"
    let year, monthIndex

    if (monthKey.includes('-')) {
      // Format: "2024-03"
      const [y, m] = monthKey.split('-')
      year = y
      monthIndex = parseInt(m, 10) - 1
    } else {
      // Fallback: parse "March 2024" format
      return monthKey
    }

    const monthName = t(`months.${monthKeys[monthIndex]}`)
    return `${monthName} ${year}`
  }

  const locale = computed({
    get: () => currentLocale.value,
    set: (val) => {
      currentLocale.value = val
      localStorage.setItem('locale', val)
      document.documentElement.lang = val
    }
  })

  const availableLocales = locales

  return { t, locale, availableLocales, formatMonth }
}

export function detectLocale() {
  const saved = localStorage.getItem('locale')
  if (saved && (saved === 'pt-BR' || saved === 'en-US')) {
    return saved
  }

  const browserLang = navigator.language || navigator.userLanguage

  if (browserLang.startsWith('pt')) {
    return 'pt-BR'
  }

  return 'en-US'
}

export function initI18n() {
  const locale = detectLocale()
  currentLocale.value = locale
  document.documentElement.lang = locale
}
